import RemoveCookies from '../RemoveCookies';
import CryptoJS from 'crypto-js';
import Cookies from 'universal-cookie';
import { redirectToAuthPortalLogout } from './authPortal';
const cookies = new Cookies();

const roles = {
  admin: {
    SubsShowMSP: false,
    insightDeviceCountForManager: false,
    ownerLockMsg: false,
    managerLockMsg: false,
    adminProfile: true,
    orgSettingsManager: false,
    deviceVPNGroupAPIAccountID: false,
    viewBuyingOptions: false,
    nonAdminWarning: false,
    buyVpnService: false,
    addInstantCPService: true,
    ragapaReports: true,
    browsingHistoryReport: false,
    buyMonthlyPlan: true,
    buyYearlyPlan: true
  },
  owner: {
    addOraganisation: false,
    actionOraganisation: false,
    editManager: false,
    deleteManager: false,
    addManager: false,
    editOwner: false,
    inviteOwner: false,
    licenseList: false,
    insightPlan: false,
    addLicense: false,
    creditsInfo: false,
    deleteLocation: false,
    adminLockMsg: false,
    managerLockMsg: false,
    adminProfile: false,
    addLocation: false,
    orgSettingsFullList: false,
    orgSettingsManager: false,
    deleteDeviceUnlockAcc: false,
    addDevice: false,
    registerNeatgear: false,
    addLAG: false,
    deleteDevice: false,
    rebootDevice: false,
    resetDevice: false,
    editLAG: false,
    addPOESchedule: false,
    POEScheduleEditDelete: false,
    addVlan: false,
    editDeleteVlan: false,
    editVlan: false,
    groupPortConfig: false,
    editDeviceName: false,
    editClientName: false,
    renameDevice: false,
    connectedPortSetting: false,
    ipSetting: false,
    clearStats: false,
    powerCycleButton: false,
    switchLeftMenu: false,
    diagnosticModeNAS: false,
    networkSettingsNAS: false,
    firmwareNAS: false,
    shutdownDevice: false,
    editSSID: false,
    deleteSSID: false,
    wirelessSetting: false,
    addSSID: false,
    apRadioChannel: false,
    updateAllFirmware: false,
    updateSingleFirmware: false,
    urlFilter: false,
    instantWifi: false,
    froaming: false,
    fbwifi: false,
    pendingAcceptance: false,
    reportGeneration: false,
    adminGraceMsg: false,
    ledSetting: false,
    firmwarePolicy: false,
    deleteNoti: false,
    shareNoti: false,
    syslog: false,
    orbiSatelliteModification: false,
    radiusConfig: false,
    brActionButtons: false,
    createBackUp: false,
    backUpActions: false,
    editTunnelDetail: false,
    dhcpServerActions: false,
    createDCHPServerBtn: false,
    createVPNGroup: false,
    createVPNUser: false,
    editVPNUser: false,
    deleteVPNGroup: false,
    vpnGroupActions: false,
    addDeviceToVPN: false,
    brPortConfig: false,
    orbiCCResumePause: false,
    addSatellite: false,
    deviceVPNGroupAPIAccountID: false,
    orbiSetup: false,
    backupActions: false,
    copyConfig: false,
    addVpnLicense: false,
    vpnlicenseList: false,
    viewBuyingOptions: false,
    buyVpnService: false,
    snmp: false,
    dnsLookUp: false,
    IPSecActions: false,
    accessPointPortConfig: false,
    addEditStaticRoute: false,
    editPortMirroring: false,
    bulkAdd: false,
    addInstantCPService: false,
    instantcpLicenseList: false,
    creditAllocation: false,
    creditsAllocationInfo: false,
    manageNotification: false,
    TechSupport: false,
    airBridgeDeviceConfig: false,
    airBridgeGroupConfig: false,
    advanceWirelessSettings: false,
    editMobile: false,
    loadBalancing: false,
    businessVPN: false,
    scheduleReboot: false,
    inviteSecondaryAdmin: false,
    downloadCSV: false,
    manageVlanCommon: false,
    MeshTopology: false,
    spanningTree: false,
    topologyDetailsButton: false,
    updateLocation: false,
    designatedBroadcast: false,
    multiPSKSettings: false,
    topologyFilter: false,
    updateRadius: false,
    editRouting: false,
    editMdnsGateway: false,
    deviceGroups: false,
    instantWiFiPreferredChannel: false,
    saseFeature: false
  },
  roManager: {
    addOraganisation: false,
    actionOraganisation: false,
    editManager: false,
    deleteManager: false,
    addManager: false,
    managerList: false,
    editOwner: false,
    inviteOwner: false,
    addLicense: false,
    SubsShowMSP: false,
    editLocation: false,
    updateLocation: false,
    updateRadius: false,
    editRouting: false,
    editMdnsGateway: false,
    deviceGroups: false,
    deleteLocation: false,
    ownerLockMsg: false,
    insightDeviceCountForManager: false,
    adminLockMsg: false,
    adminProfile: false,
    addLocation: false,
    orgSettingsFullList: false,
    deleteDeviceUnlockAcc: false,
    addDevice: false,
    registerNeatgear: false,
    addLAG: false,
    deleteDevice: false,
    rebootDevice: false,
    resetDevice: false,
    editLAG: false,
    addPOESchedule: false,
    POEScheduleEditDelete: false,
    addVlan: false,
    editDeleteVlan: false,
    editVlan: false,
    groupPortConfig: false,
    editDeviceName: false,
    editClientName: false,
    renameDevice: false,
    connectedPortSetting: false,
    ipSetting: false,
    clearStats: false,
    powerCycleButton: false,
    switchLeftMenu: false,
    diagnosticModeNAS: false,
    networkSettingsNAS: false,
    firmwareNAS: false,
    shutdownDevice: false,
    editSSID: false,
    deleteSSID: false,
    wirelessSetting: false,
    addSSID: false,
    apRadioChannel: false,
    updateAllFirmware: false,
    updateSingleFirmware: false,
    urlFilter: false,
    instantWifi: false,
    froaming: false,
    fbwifi: false,
    reportGeneration: false,
    adminGraceMsg: false,
    ledSetting: false,
    firmwarePolicy: false,
    deleteNoti: false,
    shareNoti: false,
    syslog: false,
    orbiSatelliteModification: false,
    radiusConfig: false,
    brActionButtons: false,
    createBackUp: false,
    backUpActions: false,
    editTunnelDetail: false,
    dhcpServerActions: false,
    createDCHPServerBtn: false,
    createVPNGroup: false,
    createVPNUser: false,
    editVPNUser: false,
    deleteVPNGroup: false,
    vpnGroupActions: false,
    addDeviceToVPN: false,
    brPortConfig: false,
    orbiCCResumePause: false,
    addSatellite: false,
    deviceVPNGroupAPIAccountID: false,
    orbiSetup: false,
    backupActions: false,
    copyConfig: false,
    addVpnLicense: false,
    vpnlicenseList: false,
    viewBuyingOptions: false,
    buyVpnService: false,
    locationNotifAPIUserAccountID: false,
    snmp: false,
    dnsLookUp: false,
    IPSecActions: false,
    accessPointPortConfig: false,
    addEditStaticRoute: false,
    editPortMirroring: false,
    bulkAdd: false,
    addInstantCPService: false,
    instantcpLicenseList: false,
    ragapaReports: false,
    creditAllocation: false,
    creditsAllocationInfo: false,
    manageNotification: false,
    browsingHistoryReport: false,
    TechSupport: false,
    airBridgeDeviceConfig: false,
    airBridgeGroupConfig: false,
    advanceWirelessSettings: false,
    editMobile: false,
    loadBalancing: false,
    businessVPN: false,
    scheduleReboot: false,
    inviteSecondaryAdmin: false,
    manageVlanCommon: false,
    MeshTopology: false,
    spanningTree: false,
    topologyDetailsButton: false,
    designatedBroadcast: false,
    multiPSKSettings: false,
    downloadCSV: false,
    topologyFilter: false,
    instantWiFiPreferredChannel: false,
    saseFeature: false,
    autoAllocate: false,
    allocate: false,
    deallocate: false,
    viewLicenseKey: false,
    addLmsKey: false,
    licenseKeyView: false,
    buyMonthlyPlan: false,
    buyYearlyPlan: false,
    purchaseHistory: false,
    showPurchaseHistoryTab: false,
    showChangePlan: false,
    mhsProfileWrite: false,
    addFloor: false,
    editFloor: false
  },
  rwManager: {
    addOraganisation: false,
    actionOraganisation: false,
    editManager: false,
    deleteManager: false,
    addManager: false,
    managerList: false,
    editOwner: false,
    addLicense: false,
    SubsShowMSP: false,
    ownerLockMsg: false,
    insightDeviceCountForManager: false,
    adminLockMsg: false,
    adminProfile: false,
    orgSettingsFullList: false,
    adminGraceMsg: false,
    addVpnLicense: false,
    viewBuyingOptions: false,
    buyVpnService: false,
    addInstantCPService: false,
    ragapaReports: false,
    creditAllocation: false,
    creditsAllocationInfo: false,
    browsingHistoryReport: false,
    inviteSecondaryAdmin: false,
    autoAllocate: false,
    allocate: false,
    deallocate: false,
    viewLicenseKey: false,
    addLmsKey: false,
    licenseKeyView: false,
    buyMonthlyPlan: false,
    buyYearlyPlan: false,
    showPurchaseHistoryTab: false,
    showChangePlan: false
  },
  generic: {
    deviceVPNGroupAPIAccountID: false,
    addVpnLicense: false,
    nonAdminWarning: false,
    addInstantCPService: true,
    openEditManager: false,
    manageNotification: false,
    editMobile: false,
    airBridgeTxRxChart: false,
    inviteSecondaryAdmin: false,
    downloadInvoice: true
  },
  voucherAdmin: {
    deviceVPNGroupAPIAccountID: false,
    addVpnLicense: false,
    nonAdminWarning: false,
    addOraganisation: false,
    actionOraganisation: false,
    editManager: false,
    deleteManager: false,
    addManager: false,
    managerList: false,
    editOwner: false,
    addLicense: false,
    SubsShowMSP: false,
    deleteLocation: false,
    ownerLockMsg: false,
    insightDeviceCountForManager: false,
    adminLockMsg: false,
    adminProfile: false,
    orgSettingsFullList: false,
    adminGraceMsg: false,
    viewBuyingOptions: false,
    buyVpnService: false,
    inviteOwner: false,
    editLocation: false,
    addLocation: false,
    deleteDeviceUnlockAcc: false,
    addDevice: false,
    registerNeatgear: false,
    addLAG: false,
    deleteDevice: false,
    rebootDevice: false,
    resetDevice: false,
    editLAG: false,
    addPOESchedule: false,
    POEScheduleEditDelete: false,
    addVlan: false,
    editDeleteVlan: false,
    editVlan: false,
    groupPortConfig: false,
    editDeviceName: false,
    editClientName: false,
    renameDevice: false,
    connectedPortSetting: false,
    ipSetting: false,
    clearStats: false,
    powerCycleButton: false,
    switchLeftMenu: false,
    diagnosticModeNAS: false,
    networkSettingsNAS: false,
    firmwareNAS: false,
    shutdownDevice: false,
    editSSID: false,
    deleteSSID: false,
    wirelessSetting: false,
    addSSID: false,
    apRadioChannel: false,
    updateAllFirmware: false,
    updateSingleFirmware: false,
    urlFilter: false,
    instantWifi: false,
    froaming: false,
    fbwifi: false,
    reportGeneration: false,
    ledSetting: false,
    firmwarePolicy: false,
    deleteNoti: false,
    shareNoti: false,
    syslog: false,
    orbiSatelliteModification: false,
    radiusConfig: false,
    brActionButtons: false,
    createBackUp: false,
    backUpActions: false,
    editTunnelDetail: false,
    dhcpServerActions: false,
    createDCHPServerBtn: false,
    createVPNGroup: false,
    createVPNUser: false,
    editVPNUser: false,
    deleteVPNGroup: false,
    vpnGroupActions: false,
    addDeviceToVPN: false,
    brPortConfig: false,
    orbiCCResumePause: false,
    addSatellite: false,
    orbiSetup: false,
    backupActions: false,
    copyConfig: false,
    vpnlicenseList: false,
    locationNotifAPIUserAccountID: false,
    snmp: false,
    dnsLookUp: false,
    IPSecActions: false,
    accessPointPortConfig: false,
    addEditStaticRoute: false,
    editPortMirroring: false,
    bulkAdd: false,
    manageNotification: false,
    browsingHistoryReport: false,
    TechSupport: false,
    advanceWirelessSettings: false,
    editMobile: false,
    loadBalancing: false,
    inviteSecondaryAdmin: false,
    creditAllocation: false,
    instantWiFiPreferredChannel: false
  },
  preVoucherAdmin: {
    TechSupport: false,
    editMobile: false,
    addLocation: false
  },
  supportAgent: {
    addOraganisation: false,
    actionOraganisation: false,
    editManager: false,
    deleteManager: false,
    addManager: false,
    editOwner: false,
    inviteOwner: false,
    addLicense: false,
    adminProfile: false,
    addLocation: false,
    orgSettingsManager: false,
    deleteDeviceUnlockAcc: false,
    addDevice: false,
    registerNeatgear: false,
    addLAG: false,
    deleteDevice: false,
    rebootDevice: false,
    scheduleReboot: false,
    resetDevice: false,
    editLAG: false,
    addPOESchedule: false,
    POEScheduleEditDelete: false,
    addVlan: false,
    editDeleteVlan: false,
    groupPortConfig: false,
    editDeviceName: false,
    editClientName: false,
    renameDevice: false,
    connectedPortSetting: false,
    ipSetting: false,
    clearStats: false,
    powerCycleButton: false,
    networkSettingsNAS: false,
    firmwareNAS: false,
    shutdownDevice: false,
    deleteSSID: false,
    wirelessSetting: false,
    addSSID: false,
    apRadioChannel: false,
    updateAllFirmware: false,
    updateSingleFirmware: false,
    urlFilter: false,
    instantWifi: false,
    froaming: false,
    fbwifi: false,
    pendingAcceptance: false,
    reportGeneration: false,
    ledSetting: false,
    firmwarePolicy: false,
    deleteNoti: false,
    shareNoti: false,
    syslog: false,
    orbiSatelliteModification: false,
    radiusConfig: false,
    brActionButtons: false,
    createBackUp: false,
    backUpActions: false,
    editTunnelDetail: false,
    dhcpServerActions: false,
    createDCHPServerBtn: false,
    createVPNGroup: false,
    createVPNUser: false,
    editVPNUser: false,
    deleteVPNGroup: false,
    vpnGroupActions: false,
    addDeviceToVPN: false,
    brPortConfig: false,
    orbiCCResumePause: false,
    addSatellite: false,
    deviceVPNGroupAPIAccountID: false,
    orbiSetup: false,
    backupActions: false,
    copyConfig: false,
    addVpnLicense: false,
    viewBuyingOptions: false,
    buyVpnService: false,
    snmp: false,
    IPSecActions: false,
    accessPointPortConfig: false,
    bulkAdd: false,
    addInstantCPService: false,
    creditAllocation: false,
    manageNotification: false,
    keyGeneration: false,
    IPSettingsNAS: false,
    openEditManager: false,
    airBridgeDeviceConfig: false,
    airBridgeGroupConfig: false,
    RMAEdit: false,
    addEditStaticRoute: false,
    insightSubNonPor: false,
    spanningTree: false,
    dhcpRelay: false,
    // Mobile Hotspot / Mobile Profiles CRUD — deny for support impersonation (same pattern as addDevice on supportAgent)
    mhsProfileWrite: false,
    dhcpSnooping: false,
    orgPolicy: false,
    updateManageNoti: false,
    restoreLayout: false,
    removeWidget: false,
    TechSupport: false,
    enableTroubleshoot: false,
    editPortMirroring: false,
    cableTest: false,
    MeshTopology: false,
    deleteLocation: false,
    updateLocation: false,
    updateRadius: false,
    editRouting: false,
    editMdnsGateway: false,
    deviceGroups: false,
    advanceWirelessSettings: false,
    loadBalancing: false,
    businessVPN: false,
    inviteSecondaryAdmin: true,
    instantWiFiPreferredChannel: false,
    downloadInvoice: false,
    buyMonthlyPlan: false,
    buyYearlyPlan: false,
    addLmsKey: false,
    allocate: false,
    deallocate: false,
    autoAllocate: false,
    viewLicenseKey: true,
    licenseKeyView: true,
    purchaseHistory: true,
    showChangePlan: false
  },
  secondaryAdmin: {
    SubsShowMSP: false,
    insightDeviceCountForManager: false,
    ownerLockMsg: false,
    managerLockMsg: false,
    adminProfile: true,
    orgSettingsManager: false,
    deviceVPNGroupAPIAccountID: false,
    viewBuyingOptions: false,
    buyVpnService: false,
    addInstantCPService: true,
    ragapaReports: true,
    browsingHistoryReport: false,
    inviteSecondaryAdmin: false,
    autoAllocate: true,
    allocate: true,
    deallocate: true,
    viewLicenseKey: true,
    addLmsKey: true,
    licenseKeyView: true,
    buyMonthlyPlan: false,
    buyYearlyPlan: false,
    showChangePlan: false
  },
  lineManager: {
    deviceVPNGroupAPIAccountID: false,
    nonAdminWarning: false,
    addOraganisation: false,
    actionOraganisation: false,
    editOwner: false,
    SubsShowMSP: false,
    ownerLockMsg: false,
    insightDeviceCountForManager: false,
    adminLockMsg: false,
    adminProfile: false,
    orgSettingsFullList: false,
    adminGraceMsg: false,
    deleteDeviceUnlockAcc: false,
    registerNeatgear: false,
    addPOESchedule: false,
    POEScheduleEditDelete: false,
    groupPortConfig: false,
    connectedPortSetting: false,
    deleteNoti: false,
    shareNoti: false,
    syslog: false,
    locationNotifAPIUserAccountID: false,
    accessPointPortConfig: false,
    manageNotification: false,
    TechSupport: false,
    creditAllocation: false
  }
};

/**
 * Clears account cookies and redirects to auth portal login.
 * @param {boolean} [skipIfRedirectCookiesSet=true] - When true, does nothing if redirectCookies is set; when false, always performs redirect.
 */
function redirectToLogin(skipIfRedirectCookiesSet = true) {
  if (skipIfRedirectCookiesSet && cookies.get('redirectCookies')) {
    return;
  }
  RemoveCookies.removeAccCookies().then((logout) => {
    if (logout) {
      redirectToAuthPortalLogout();
    }
  });
}

export default {
  checkUser: function (featureKey) {
    try {
      let userRole = cookies.get('userRole');
      const userSubRole = cookies.get('userSubRole');
      const email = localStorage.getItem('email');

      // If email is missing (session expired), redirect to login; fail closed so features stay disabled until redirect
      if (!email) {
        redirectToLogin();
        return false;
      }

      if (userRole) {
        const decryptKey = email.split('@')[0].toLowerCase();
        userRole = CryptoJS.AES.decrypt(cookies.get('userRole'), decryptKey).toString(CryptoJS.enc.Utf8);

        let decryptedSubRole = null;
        if (userSubRole != undefined && userSubRole) {
          decryptedSubRole = CryptoJS.AES.decrypt(cookies.get('userSubRole'), decryptKey).toString(CryptoJS.enc.Utf8);
          if (!decryptedSubRole || !roles[decryptedSubRole]) {
            decryptedSubRole = null;
          }
        }

        if (decryptedSubRole) {
          const roleDenied = roles[userRole]?.[featureKey] === false;
          const subRoleDenied = roles[decryptedSubRole]?.[featureKey] === false;
          if (roleDenied || subRoleDenied) {
            return false;
          }
          return true;
        }

        if (roles[userRole] && roles[userRole][featureKey] != undefined) {
          return roles[userRole][featureKey];
        }
        return true;
      }

      return true;
    } catch (error) {
      console.error('Error in checkUser:', error);
      // On any unexpected error, redirect to login; fail closed so features stay disabled until redirect
      redirectToLogin();
      return false;
    }
  },
  getUserRole: function () {
    try {
      const userRoleCookie = cookies.get('userRole');
      const email = localStorage.getItem('email');

      if (!userRoleCookie) {
        throw new Error('userRole cookie missing');
      }
      if (!email) {
        throw new Error('email missing');
      }

      const decryptedRole = CryptoJS.AES.decrypt(userRoleCookie, email.split('@')[0].toLowerCase()).toString(CryptoJS.enc.Utf8);
      return decryptedRole;
    } catch (error) {
      // clear all local storage and Cookies as the same case in Logout function
      if (!cookies.get('redirectCookies')) {
        RemoveCookies.removeAccCookies().then((logout) => {
          if (logout) redirectToAuthPortalLogout();
        });
      }
    }
  },
  getUserSubRole: function () {
    try {
      const userSubRoleCookie = cookies.get('userSubRole');
      const email = localStorage.getItem('email');

      if (!userSubRoleCookie) {
        return null; // userSubRole is optional, return null if not present
      }
      if (!email) {
        throw new Error('email missing');
      }

      const decryptedSubRole = CryptoJS.AES.decrypt(userSubRoleCookie, email.split('@')[0].toLowerCase()).toString(CryptoJS.enc.Utf8);
      // Check if decryption was successful (empty string means decryption failed)
      if (!decryptedSubRole || decryptedSubRole.trim() === '') {
        return null;
      }
      return decryptedSubRole;
    } catch (error) {
      console.error('Error in getUserSubRole:', error);
      return null; // Return null on error instead of throwing
    }
  },
  /**
   * Whether the given role/subRole may grant Support Access. Fail-closed.
   * Granting TSM is account consent, not an org write, so read-only managers
   * are allowed. Flag-on stamps `roManager` from context accessType; flag-off
   * often left them as `rwManager` / role "2", which is why Grant appeared
   * only when the flag was off.
   * Still deny owner, voucherAdmin, preVoucherAdmin, supportAgent, lineManager,
   * and any sub-role with TechSupport: false.
   */
  canGrantSupportAccessFromRoles: function (userRole, userSubRole) {
    if (!userRole) return false;
    if (userSubRole && (!roles[userSubRole] || roles[userSubRole].TechSupport === false)) {
      return false;
    }
    if (userRole === 'roManager') {
      return true;
    }
    if (roles[userRole] && roles[userRole].TechSupport === false) return false;
    return true;
  },
  /**
   * Whether the current user may grant Support Access. Fail-closed.
   * Owner stays denied. Read-only managers may grant (see canGrantSupportAccessFromRoles).
   * Also denies when sub-role restricts (e.g. supportAgent with TechSupport: false).
   */
  // canGrantSupportAccess: function () {
  //     let userRole;
  //     try {
  //         userRole = this.getUserRole();
  //     } catch (e) {
  //         return false;
  //     }
  //     // Deny for read-only: manager read-only (roManager) and owner (read-only)
  //     if (!userRole || userRole === 'roManager' || userRole === 'owner') {
  //         return false;
  //     }
  //     const userSubRole = this.getUserSubRole();
  //     return this.canGrantSupportAccessFromRoles(userRole, userSubRole);
  // },
  getAccStatus: function () {
    try {
      if (cookies.get('AccStatus')) {
        return CryptoJS.AES.decrypt(cookies.get('AccStatus'), localStorage.getItem('email').split('@')[0].toLowerCase()).toString(
          CryptoJS.enc.Utf8
        );
      } else {
        return 'locked';
      }
    } catch (error) {
      // clear all local storage and Cookies as the same case in Logout function
      RemoveCookies.removeAccCookies().then((logout) => {
        if (logout) redirectToAuthPortalLogout();
      });
    }
  },
  getOrgStatus: function () {
    try {
      if (cookies.get('OrgStatus')) {
        return CryptoJS.AES.decrypt(cookies.get('OrgStatus'), localStorage.getItem('email').split('@')[0].toLowerCase()).toString(
          CryptoJS.enc.Utf8
        );
      } else {
        return '';
      }
    } catch (error) {
      // clear all local storage and Cookies as the same case in Logout function
      RemoveCookies.removeAccCookies().then((logout) => {
        if (logout) redirectToAuthPortalLogout();
      });
    }
  },
  getIsNeedToAssg: function () {
    try {
      if (cookies.get('isLocNeedToAssg')) {
        return CryptoJS.AES.decrypt(cookies.get('isLocNeedToAssg'), localStorage.getItem('email').split('@')[0].toLowerCase()).toString(
          CryptoJS.enc.Utf8
        );
      } else {
        return 'yes';
      }
    } catch (error) {
      // clear all local storage and Cookies as the same case in Logout function
      RemoveCookies.removeAccCookies().then((logout) => {
        if (logout) redirectToAuthPortalLogout();
      });
    }
  },
  getUserPlan: function () {
    try {
      return JSON.parse(
        CryptoJS.AES.decrypt(
          cookies.get('userPlan'),
          localStorage.getItem('email').split('@')[0].toLowerCase() + cookies.get('userid')
        ).toString(CryptoJS.enc.Utf8)
      );
    } catch (error) {
      // clear all local storage and Cookies as the same case in Logout function
      if (!cookies.get('redirectCookies')) {
        RemoveCookies.removeAccCookies().then((logout) => {
          if (logout) redirectToAuthPortalLogout();
        });
      }
    }
  }
};
